<template>
    <div class="phseachs" >
        <el-backtop ></el-backtop>
        <hpheader></hpheader>
<!--        <div class="phseachs-input">-->
<!--            <div class="phseachsinput-cont">-->
<!--                <div class="seachinp">-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phseachsimg/phseachinput.png" />-->
<!--                    <input :placeholder="seaplac" @focus="seahotb"  v-model="keywords" />-->
<!--                </div>-->
<!--                <div class="inputcon-but"  @click="hanldeSearch('enter')" >-->
<!--                    {{btn}}-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="search-bar">
            <el-autocomplete
                    v-model="keywords"
                    :fetch-suggestions="querySearchAsync"
                    placeholder=""
                    @select="handleSelect"
                    prefix-icon="el-icon-search"
                    @input="get_hot_search"
                    @focus="focusAutocomplete"
            >
                <div slot="suffix" class="el-input-btn">
                    <div class="inputcon-but" @click="hanldeSearch('enter')">{{btn}}</div>
                </div>
            </el-autocomplete>
        </div>
        <div class="seach-contew" >
            <div class="seach-nav">
                <div class="nav-item" :class="seainad==1?'seacling':''" @click='seaacind(1)'>{{seaproduct}}</div>
                <div class="nav-item" :class="seainad==2?'seacling':''" @click='seaacind(2)'>{{seavideo}}</div>
                <div class="nav-item" :class="seainad==3?'seacling':''" @click='seaacind(3)'>{{seaquery}}</div>
            </div>
            <div class="seach-number" >
                {{sealeft}} {{list_length}} {{searight}}
            </div>

            <div class="seach-prooverall" v-if="seainad==1">
                <div class="prooverall-item" v-for="(item,index) in list" @click="detailto(item.id)" :key="index">
                    <div class="proallitem-img">
                        <img :src="item.menu_image" alt="">
                    </div>
                    <div class="proallitem-title">{{item.name}}</div>
                    <div class="proallitem-name">{{item.name_content}}</div>
                </div>
            </div>
            <div class="seach-vidoverall" v-if="seainad==2">
                <div class="vidoverall-item" v-for="(item,index) in list" :key="index">
                    <div class="vidallitem-img">
                        <video :src="item.video" :poster="item.image" controls></video>
                    </div>
                    <div class="vidallitem-title">{{item.title}}</div>
                </div>
            </div>
            <div class="seach-prooverall" v-if="seainad==3">
                <div class="prooverall-item"v-for="(item,index) in list" :key="index">
                    <div class="proallitem-img">
                        <img :src="item.image" alt="">
                    </div>
                    <div class="proallitem-title">{{item.title}}</div>
                    <div class="proallitem-name querallitem-name" >
                        <span @click="openFile(item)">{{onlinepreview}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div ref="bottom" style="width: 100%;height: .5rem;"></div>
    </div>
</template>

<script>
    import hpheader from '../../common/hpheader.vue'
    import hpfooter from '../../common/hpfooter.vue'
    import {session} from "../../storage/storage";
    export default{
        data(){
            return{
                seainad:1,
                hotseano:true,
                keywords:"",
                list:[],
                list_length:0,
                btn:"",
                seaplac:'',
                seaproduct:'',
                seavideo:'',
                seaquery:'',
                sealeft:'搜到',
                searight:'条结果',
                onlinepreview:'在线预览',
                sevideotcon:'',
                acindex:1,
                seachinput:'',
                lcategoryidlist:'',
                videoclassliststt:'',
                lcategoryidlistleng:0,
                videoclassliststtleng:0,
                filearr:[],
                downloadlistst:'',
                downloadliststlength:0,
                options: [],
                optionslang: [],
                value: '',
                valuelang: '',
                list_img: [],
                page:0,
                totalPage:0,
                pageSize:10,
                get:false,
                subSearch:false,
                restaurants:[],
                elAutocompleteSuggestion:''
            }
        },
        created() {
            window.scrollTo(0,0);
            this.ress()
            this.pageParam()

        },
        mounted(){
            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            this.elAutocompleteSuggestion = document.getElementsByClassName('el-autocomplete-suggestion')[0]
            this.get_hot_search()
            this.hanldeSearch('enter')
        },
        components:{
            hpfooter,
            hpheader
        },
        methods:{
            get_hot_search(){
                this.elAutocompleteSuggestion.classList.remove('hidden-el-autocomplete-suggestion')
                if(this.subSearch){
                    return
                }
                this.subSearch = true
                let _this =  this,lang = session.get('lang')
                _this.restaurants = []
                _this.$api.get_hot_search({
                    lang,
                    type:_this.seainad,
                    keyword:_this.keywords,
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                }).then(res  => {
                    res.data.forEach(function (v) {
                        _this.restaurants.push({value:v})
                    })
                    this.subSearch = false
                })
            },
            querySearchAsync(queryString, cb) {
                // var restaurants = this.restaurants;
                // var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
                cb(this.restaurants)
            },
            createStateFilter(queryString) {
                return (seachinput) => {
                    return (seachinput.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.keywords = item.value
                this.hanldeSearch('enter')
            },
            focusAutocomplete(){
                this.elAutocompleteSuggestion.classList.remove('hidden-el-autocomplete-suggestion')
            },
            openFile(item){
                window.open(item.file)
            },
            handleScroll(){
                if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
                    this.hanldeSearch()
                }
            },
            pageParam(){
                let lang =  session.get("lang");
                if (lang === "cn"){
                    this.btn = "搜索"
                    this.seaplac = ""
                    this.seaproduct="产品"
                    this.seavideo='视频'
                    this.seaquery='服务'
                    this.sealeft='搜到'
                    this.searight='条结果'
                    this.onlinepreview='在线预览'

                }else{
                    this.btn = "search"
                    // this.seaplac = "Please enter product name keyword"
                    this.seaproduct="Products"
                    this.seavideo='Video'
                    this.seaquery='Service'
                    this.sealeft='Found'
                    this.searight='Results'
                    this.onlinepreview='Online Preview'
                }
            },
            hanldeSearch(type=''){
                if(type == 'enter'){
                    this.page = 0
                    this.list = []
                    this.list_length = 0
                    this.totalPage = 0
                    this.elAutocompleteSuggestion.classList.add('hidden-el-autocomplete-suggestion')
                }
                if(this.totalPage != 0 && this.totalPage <= this.page){
                    return
                }
                if(this.get){
                    return;
                }
                this.get = true
                this.page++
                if (this.seainad == 1){
                    this.pcchannelcategoryidlist()
                }else if (this.seainad == 2){
                    this.videoclasslist()
                }else if (this.seainad == 3){
                    this.pcdownloadlist()
                }
            },
            pcchannelcategoryidlist(){ //产品搜索内容
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.page,
                    pageSize:this.pageSize,
                    mold:"h5",
                    keyword:this.keywords
                }
                this.$api.get_product_list(data).then((res) => {
                    this.list=this.list.concat(res.data.data)
                    this.list_length=res.data.total
                    this.totalPage = Math.ceil(res.data.total/this.pageSize)
                    this.get = false
                });
            },
            videoclasslist() { //视频搜索内容
                let data = {
                    lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold: 'h5',
                    page: this.page,
                    pageSize: this.pageSize,
                    keyword: this.keywords
                }
                this.$api.get_video_list(data).then((res) => {
                    this.list=this.list.concat(res.data.data)
                    this.list_length=res.data.total
                    this.totalPage = Math.ceil(res.data.total/this.pageSize)
                    this.get = false
                });
            },
            pcdownloadlist(){
                let data={
                    mold:'h5',
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.page,
                    pageSize:this.pageSize,
                    keyword: this.keywords
                }
                this.$api.get_download_list(data).then((res) => {
                    this.list=this.list.concat(res.data.data)
                    this.list_length=res.data.total
                    this.totalPage = Math.ceil(res.data.total/this.pageSize)
                    this.get = false
                });
            },
            seahotb(){
                this.hotseano=false
            },
            seaacind(e){
                this.seainad=e
                this.list = []
                this.page = 0
                this.list_length = 0
                this.keywords = ''
                this.get_hot_search()
                this.hanldeSearch('enter')
            },
            ress(){
                var html = document.documentElement; //获取根元素
                var designWidth = 750; //设计稿宽度
                //html.clientWidth 视口宽度
                html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
            },
            detailto(e){
                this.$router.push({path: '/pcdetails',query:{e,type:'pc'}})
            },
        }
    }
</script>

<style>
    body{
        margin: 0;
        padding: 0;
    }
    .phseachs{
        background: #FFF;
        padding-top: 0.88rem;
    }
    .phhonor-hea{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 7.5rem;
        height: 0.88rem;
        background: #FFFFFF;
    }
    .phhonorhea-left{
        margin-left: 0.3rem;
        width: 0.97rem;
        height: 0.5rem;
    }
    .phhonorhea-left img{
        width: 100%;
        height: 100%;
    }
    .phhonorhea-right{
        margin-right: 0.3rem;
        width: 0.38rem;
        height: 0.38rem;
    }
    .phhonorhea-right img{
        width: 100%;
        height: 100%;
    }
    .phseachs-input{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .phseachsinput-cont{
        display: flex;
        align-items: center;
        width: 6.89rem;
        height: 0.84rem;
        background: #F7F7F7;
        /* background: #000; */
        border-radius: 0.42rem;
        margin-top: 0.5rem;
    }
    .seachinp{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .seachinp img{
        width: 0.36rem;
        height: 0.36rem;
        margin-left: 0.24rem;
        margin-right: 0.16rem;
    }
    .seachinp input{
        height: 0.84rem;
        width: 4.2rem;
        border: none;
        background: #F7F7F7;
        outline: none;
    }
    .inputcon-but{
        width: 1.3rem;
        height: 0.6rem;
        background: #E31E24;
        border-radius: 0.3rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 0.01rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 0.42rem;
    }
    .seach-nav{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .nav-item{
        margin-right: 0.6rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;

    }
    .nav-item:last-child{
        margin-right: 0rem;
    }
    .seach-number{
        font-size: 0.28rem;
        font-weight: 400;
        color: #999999;
        letter-spacing: 0.01rem;
        margin-left: 0.3rem;
        margin-top: 0.38rem;

    }
    .seach-prooverall{
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.4rem;
    }
    .prooverall-item{
        margin-left: 0.3rem;
        margin-bottom: 0.4rem;
        width: 3.3rem;
    }
    .proallitem-img{
        width: 3.3rem;
        height: 3.3rem;
    }
    .proallitem-img img{
        width: 100%;
        height: 100%;
        border-radius: 0.08rem;
    }
    .proallitem-title{
        font-size: 40px;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-top: 0.2rem;
    }
    .proallitem-name{
        font-size: 40px;
        font-weight: 500;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-top: 0.12rem;
    }
    .hotseach{
        margin-left: 0.3rem;
    }
    .hotseach-hea{
        font-size: 0.28rem;
        font-weight: 400;
        color: #999999;
        letter-spacing: 0.01rem;
    }
    .hotseachitem{
        display: flex;
        align-items: center;
        width: 6.9rem;
        height: 1.2rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        border-bottom: solid 0.01rem #999;
    }
    .seacling{
        color: #D03E3D;
    }
    .seach-vidoverall{
        margin-left: 0.3rem;
    }
    .vidoverall-item{

        margin-bottom: 0.34rem;
    }
    .vidoverall-item:first-child{

        margin-top: 0.4rem;
    }
    .vidallitem-img{
        width: 6.9rem;
        height: 3.88rem;

    }
    .vidallitem-img video{
        width: 100%;
        height: 100%;
    }
    .vidallitem-title{
        font-size: 0.28rem;
        font-weight: 500;
        color: #5d5f5f;
        margin-top: 0.25rem;
    }
    .seach-queroverall{
        margin-left: 0.3rem;
    }
    .queroverall-item{
        margin-top: 0.4rem;
        margin-bottom: 0.34rem;
    }
    .querallitem-img{
        width: 6.9rem;
        height: 3.88rem;
    }
    .querallitem-img img{
        width: 100%;
        height: 100%;
    }
    .querallitem-title{
        font-size: 0.32rem;
        font-weight: 500;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-top: 0.24rem;
    }
    .querallitem-name{
        /*margin-top: 0.24rem;*/
        /*text-align: center;*/
        /*width: 1.29rem;*/
        /*font-size: 0.28rem;*/
        /*font-weight: 400;*/
        color: #D03E3D;
        /*letter-spacing: 0.01rem;*/
        font-size: 36px;
    }
    .querallitem-name span {
        border-bottom: 0.01rem solid #D03E3D;
    }
    .seach-contew{
        margin-top: 0.5rem;
    }

    .search-bar {
        width: 90%;
        margin: 0 auto;
    }
    .search-bar .el-autocomplete {
        width: 100%;
    }
    .search-bar .el-autocomplete .el-input {
        width: 100%;
        max-width: 100%;
    }
    .search-bar .el-autocomplete .el-input__inner:focus {
        border: 0;
    }
    .search-bar .el-autocomplete .el-input input{
        border-radius: 100px;
        background-color: #F7F7F7;
        border: 0;
        caret-color:#5d5f5f;
        line-height: normal
    }
    .el-input-btn {
        display: flex;
        justify-items: center;
        align-items: center;
        height: 100%;
    }
    .hidden-el-autocomplete-suggestion {
        display: none;
    }
</style>
